import { z } from 'zod';
import { ActionTypeSchema } from './actions/actionTypes';
export var ClientDataSchema = z.object({
    email: z.string().nullable().optional(),
    loggedIn: z.boolean().optional(),
    STRIPE_CUSTOMER_PORTAL_URL: z.union([
        z.string(), z.boolean(), z.null(), z.undefined()
    ]).optional(),
    activationCode: z.string().optional(),
    score_data: z.object({
        products: z.record(z.string(), z.number()),
        memo: z.string()
    }).optional()
});
var ActionSchema = z.object({
    type: ActionTypeSchema,
    key: z.string().optional(),
    value: z.unknown().optional(),
    data: ClientDataSchema.optional()
});
